import { useState, useEffect, useCallback } from "react";
import { Cart } from "../../types/models/mvcapi";
import { useCartControl } from "../../logic/hooks/use-cart-control";

export function useCartInfo(): [Cart, boolean, () => void] {
    const [ cart, setCart ] = useState<Cart>(null);
    const [ cartLoading, setCartLoading ] = useState<boolean>(true);
    const cartControl = useCartControl();

    const refresh = useCallback(() => {
        setCartLoading(true);
        const loadCart = async () => {
            const cartRequest = await tsapp.mvcapi.postCtl("cart/cart", null, { cache: false });
            if(cartRequest.IsSuccess)
                setCart(cartRequest.Cart);
            setCartLoading(false);
        };
        loadCart();
    }, [setCartLoading, setCart]);

    useEffect(() => {
        refresh();
    }, [refresh]);

    useEffect(() => {
        if(cartControl) {
            cartControl.onRefreshCart(refresh);
        }
        return () => {
            if(cartControl) {
                cartControl.offRefreshCart(refresh);
            }
        };
    }, [cartControl, refresh]);

    return [ cart, cartLoading, refresh ];
}

